<template>
	<header class="app-header">
		<div class="container">
			<h1>{ {{name}} <span>{{desc}}</span> }</h1>
		</div>
	</header>
</template>

<script>
export default {
	name: 'appHeader',
	props: ['name', 'desc'],
	data () {
		return {
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// appHeader.vue?50acdd4c